__turbopack_context__.v({
  "UiArtistImageGallery": "splide-module__Ip5c-q__UiArtistImageGallery",
  "UiArtistImageGallery__arrows": "splide-module__Ip5c-q__UiArtistImageGallery__arrows",
  "UiArtistImageGallery__track": "splide-module__Ip5c-q__UiArtistImageGallery__track",
  "UiArtistImageGallery__track__slide": "splide-module__Ip5c-q__UiArtistImageGallery__track__slide",
  "UiCarousel": "splide-module__Ip5c-q__UiCarousel",
  "UiCarousel__arrows__middle": "splide-module__Ip5c-q__UiCarousel__arrows__middle",
  "UiCarousel__arrows__top": "splide-module__Ip5c-q__UiCarousel__arrows__top",
  "UiCarousel__pagination": "splide-module__Ip5c-q__UiCarousel__pagination",
  "UiCarousel__pagination__dot": "splide-module__Ip5c-q__UiCarousel__pagination__dot",
  "UiCarousel__pagination__dot__active": "splide-module__Ip5c-q__UiCarousel__pagination__dot__active",
  "UiCarousel__track": "splide-module__Ip5c-q__UiCarousel__track",
  "UiCarousel__track__slide": "splide-module__Ip5c-q__UiCarousel__track__slide",
  "UiGridCarousel": "splide-module__Ip5c-q__UiGridCarousel" + " " + "splide-module__Ip5c-q__UiCarousel",
  "UiGridCarousel__track": "splide-module__Ip5c-q__UiGridCarousel__track" + " " + "splide-module__Ip5c-q__UiCarousel__track",
  "UiGridCarousel__track__slide": "splide-module__Ip5c-q__UiGridCarousel__track__slide" + " " + "splide-module__Ip5c-q__UiCarousel__track__slide",
  "UiProductImageGallery": "splide-module__Ip5c-q__UiProductImageGallery",
  "UiProductImageGallery__track": "splide-module__Ip5c-q__UiProductImageGallery__track",
  "UiProductImageGallery__track__slide": "splide-module__Ip5c-q__UiProductImageGallery__track__slide",
  "privateRoomGallery__arrows": "splide-module__Ip5c-q__privateRoomGallery__arrows",
  "privateRoomGallery__carousel__track": "splide-module__Ip5c-q__privateRoomGallery__carousel__track",
  "privateRoomGallery__carousel__track__slide": "splide-module__Ip5c-q__privateRoomGallery__carousel__track__slide",
  "privateRoomGallery__grid__track": "splide-module__Ip5c-q__privateRoomGallery__grid__track",
  "privateRoomGallery__wrapper": "splide-module__Ip5c-q__privateRoomGallery__wrapper",
});
